<template>
    <div>

        <div id="topbar">
            <div class="container">
                Nunca foi tão fácil encontrar novos clientes!
            </div>
        </div>

        <div id="middle">
            <div class="container">
                <p id="title">Pacotes de créditos</p>
                <div class="columns">
                    <div class="column" v-for="p in packages">
                        <div class="plan">
                            <div class="planhead">
                                {{p.title}}
                            </div>
                            <div class="planprice">
                                {{parseFloat(p.price).toFixed(2).replace('.',',')}}  €
                                <p><a :href="appUrl + '/creditos'" class="button is-primary is-inverted">Comprar</a></p>
                            </div>
                            <div class="planline white"><b>{{p.credits}}</b> Créditos</div>
                            <div class="planline grayl"><b>{{(p.price/p.credits).toFixed(2).toString().replace('.',',')}} €</b> por crédito</div>
                            <div class="planline white"><b>{{p.pictures}}</b> fotografias</div>
                            <div class="planline grayl"><b>Certificações</b> visíveis</div>
                            <div class="planline white"><b>Acesso</b> a MLS*</div>
                            <div class="planline grayl"><b>Chat</b> directo com clientes</div>
                            <div class="planline white"><b>Página de Perfil</b></div>
                            <div class="planline grayl">{{p.benefits[0] ? p.benefits[0].title : '&nbsp;'}}</div>
                            <div class="planline white">{{p.benefits[1] ? p.benefits[1].title : '&nbsp;'}}</div>
                            <div class="planline grayl">{{p.benefits[2] ? p.benefits[2].title : '&nbsp;'}}</div>
                        </div>
                    </div>

                </div>
                <p id="disclaimer">
Todos os preços excluem IVA. Após o pagamento, os créditos serão adicionados à sua conta automaticamente.<br>
                    * Apenas para profissionais do Imobiliário.
                </p>
            </div>

        </div>

        <div id="bottom">
            <img src="/static/images/pricing/bannerpacotes.jpg" alt="">
        </div>

    </div>
</template>

<script>
import { appUrl } from "../vars";
import { apiUrl } from "../vars";
import {scrollTop} from "../plugins/scrollTopMixin";

export default {
	mixins: [scrollTop],

	data() {
    return {
      packages: [],
      appUrl
    };
  },
  methods: {
    getPackages() {
      axios.get(apiUrl + "/api/packages").then(r => {
        this.packages = r.data.packages;
      });
    }
  },
  created() {
    this.getPackages();
  },
  destroyed() {}
};
</script>
<style scoped>
#disclaimer {
  font-size: 0.8rem;
  color: #969696;
  margin-bottom: 3rem;
}

.plan {
  border: solid 1px #969696;
}

.planhead {
  color: #2d3256;
  font-size: 2rem;
  font-weight: 600;
  text-align: center;
  padding: 1rem;
  background-color: #f1f1f1;
}

.planprice {
  background-color: #e90054;
  color: white;
  text-align: center;
  padding: 1rem;
  line-height: 3rem;
  font-size: 2.5rem;
  font-weight: 700;
}

.planprice p {
  margin: 1rem 0 0;
}

.planline {
  color: black;
  text-align: left;
  padding: 0 1rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 2.25rem;
}

.white {
  background-color: #ffffff;
  color: black;
}

.grayl {
  background-color: #f1f1f1;
  color: black !important;
}

#title {
  color: black;
  font-weight: 500;
  text-align: center;
  font-size: 1.5rem;
  padding: 1.5rem;
}

#topbar {
  background-color: #2d3256;
  background-image: url("/static/images/pricing/imagemsky.jpg");
  background-size: cover;
  background-position: center;
  color: white;
  font-weight: 600;
  line-height: 2.5rem;
  font-size: 1.75rem;
}

#bottom {
  min-height: 31vw;
  position: relative;
}

#bottom img {
  position: absolute;
  bottom: 0;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/Pricing.vue